var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"altura"},[_c('b-row',[_c('b-col',{staticClass:"mb-2 mb-lg-4",attrs:{"cols":"12"}},[_c('PageTitle',{staticClass:"mt-2",attrs:{"title":"Termos e condições"}})],1)],1),_c('TermsAndPrivacyComponent',{attrs:{"isTerm":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }